module.exports = __webpack_public_path__ + "img/illustration-delete.463861e6.svg";